import { Component, Story, Knobs, TextTypes, Icons } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  image: {
    default:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
    editor: 'textbox',
  },
  placeholder: {
    default: 'GS',
    editor: 'textbox',
  },
  heading: {
    default: 'Martin Zane',
    editor: 'textbox',
  },
  headingType: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(TextTypes),
  },
  subTitle1: {
    default: 'UX Designer',
    editor: 'textbox',
  },
  subTitle1Type: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(TextTypes),
  },
  subTitle2: {
    default: 'Leeds',
    editor: 'textbox',
  },
  subTitle2Type: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(TextTypes),
  },
  linkText1: {
    default: 'martin.zane@demo.com',
    editor: 'textbox',
  },
  linkHref1: {
    default: 'mailto:martin.zane@demo.com',
    editor: 'textbox',
  },
  text1: {
    default: '+44 (0) 845 345 3300',
    editor: 'textbox',
  },
  text1Type: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(TextTypes),
  },
  width: {
    default: '',
    editor: 'textbox',
  },
  button1Icon: {
    default: 'CircleInfo',
    editor: 'dropdown',
    editorOptions: Icons,
  },
  button2Icon: {
    default: 'Email',
    editor: 'dropdown',
    editorOptions: Icons,
  },
  button3Icon: {
    default: 'History',
    editor: 'dropdown',
    editorOptions: Icons,
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-card-profile where you can change all the attributes',
  coreComponent: {
    html: `<tag-card-profile{{...knobs}}>
</tag-card-profile>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: { jsx: `<TagCardProfile{{...knobs}} />`, knobs: PlaygroundKnobs },
};

const SlotsStory: Story = {
  title: 'Slots',
  description: 'A tag-card-profile where slots are used to specify content',
  coreComponent: {
    html: `<tag-card-profile
  width='230px'
  image='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'>
  <div slot='header'>
    <tag-text type='h2' text='Martin Zane'></tag-text>
  </div>
  <div slot='content'>
    <tag-link href='mailto:martin.zane@demo.com' text='martin.zane@demo.com'></tag-link>
  </div>
  <div slot='buttons' style='margin-top:15px; margin-bottom:15px;'>
    <tag-button icon='History' text='View History'></tag-button>
  </div>
</tag-card-profile>`,
  },
  reactWrapper: {
    jsx: `<TagCardProfile
  width='230px'
  image='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'>
  <div slot='header'>
    <TagText type='h2' text='Martin Zane' />
  </div>
  <div slot='content'>
    <TagLink href='mailto:martin.zane@demo.com' text='martin.zane@demo.com' />
  </div>
  <div slot='buttons' style={{marginTop: "15px", marginBottom: "15px"}}>
    <TagButton icon='History' text='View History' />
  </div>
</TagCardProfile>`,
  },
};

export const TagCardProfileDocs: Component = {
  type: 'component',
  name: 'card-profile',
  description: 'Displays profile information in a card',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'width',
      description: 'The width of the card',
      type: 'string',
    },
    {
      name: 'placeholder',
      description: 'A placeholder text when there is no image',
      type: 'string',
    },
    {
      name: 'image',
      description: 'The source of the profile image',
      type: 'string',
    },
    {
      name: 'heading',
      description: 'The heading for the card',
      type: 'string',
    },
    {
      name: 'headingType',
      description: 'The heading type',
      type: 'string',
    },
    {
      name: 'headingStyle',
      description: 'JSX style object in JSON to apply to the heading',
      type: 'string',
    },
    {
      name: 'subTitle1',
      description: 'A string to be displayed under the heading',
      type: 'string',
    },
    {
      name: 'subTitle1Type',
      description: 'The subtitle1 type',
      type: 'string',
    },
    {
      name: 'subTitle1Style',
      description: 'JSX style object in JSON to apply to the element',
      type: 'string',
    },
    {
      name: 'subTitle2',
      description: 'A string to be displayed under subTitle1',
      type: 'string',
    },
    {
      name: 'subTitle2Type',
      description: 'The subtitle2 type',
      type: 'string',
    },
    {
      name: 'subTitle2Style',
      description: 'JSX style object in JSON to apply to the element',
      type: 'string',
    },
    {
      name: 'text1',
      description: 'A string to be displayed under the titles',
      type: 'string',
    },
    {
      name: 'text1Type',
      description: 'The text1 type',
      type: 'string',
    },
    {
      name: 'text1Style',
      description: 'JSX style object in JSON to apply to the element',
      type: 'string',
    },
    {
      name: 'text2',
      description: 'A string to be displayed under text1',
      type: 'string',
    },
    {
      name: 'text2Type',
      description: 'The text2 type',
      type: 'string',
    },
    {
      name: 'text2Style',
      description: 'JSX style object in JSON to apply to the element',
      type: 'string',
    },
    {
      name: 'linkText1',
      description: 'A link to be displayed',
      type: 'string',
    },
    {
      name: 'linkHref1',
      description: 'The href for link1',
      type: 'string',
    },
    {
      name: 'link1Style',
      description: 'JSX style object in JSON to apply to the element',
      type: 'string',
    },
    {
      name: 'linkText2',
      description: 'A link to be displayed',
      type: 'string',
    },
    {
      name: 'linkHref2',
      description: 'The href for link2',
      type: 'string',
    },
    {
      name: 'link2Style',
      description: 'JSX style object in JSON to apply to the element',
      type: 'string',
    },

    {
      name: 'button1Icon',
      description: 'The icon for the 1st option',
      type: 'string',
    },
    {
      name: 'button2Icon',
      description: 'The icon for the 2nd option',
      type: 'string',
    },
    {
      name: 'button3Icon',
      description: 'The icon for the 3rd option',
      type: 'string',
    },
    {
      name: 'button4Icon',
      description: 'The icon for the 4th option',
      type: 'string',
    },
    {
      name: 'button5Icon',
      description: 'The icon for the 5th option',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'buttonClick',
      description: 'Raised when a button is clicked',
      parameters: [
        {
          name: 'index',
          description: 'The button number (starting from 1)',
          type: 'number',
        },
      ],
    },
  ],
  methods: [],
  stories: [PlaygroundStory, SlotsStory],
};
